import React from 'react';
import '../CSS/Navbar.css';
import { getBrandingValue } from '../utils/subdomainUtils';

function Navbar({ cartTotal, onViewCart }) {
  const logoPath = getBrandingValue('logo');
  const title = getBrandingValue('title');
  
  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logoPath} alt={`${title} Logo`} />
      </div>
      <div className="cart-section">
        <span className="cart-total">${cartTotal.toFixed(2)}</span>
        <button className="view-cart-btn" onClick={onViewCart}>
          View Cart
        </button>
      </div>
    </nav>
  );
}

export default Navbar; 